import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHTML'
})

export class StripHTMLPipe implements PipeTransform {
    transform(value: any): any {
    return  value ? String(value).replace(/<[^>]+>/gm, '') : '';
   }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/strip-html.pipe.ts